import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const ProgramssPageSession = React.lazy(() => import('../programs/eiprogram/ProgramsPageSession'));
const ProgramsPageHeader = React.lazy(() => import('../programs/eiprogram/ProgramsPageHeader'));

function ProgramsPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <ProgramsPageHeader />
       <ProgramssPageSession />
      </Suspense>
    </div>
  );
}

export default ProgramsPage;
